/**
 * Étiquette Zebra UNIQUE d'une livraison (19/10/2026) — 50 × 25 mm, paysage.
 *
 * Décision de Philippe après la 1re tournée : une seule étiquette par
 * livraison, avec le nombre de colis, plutôt qu'un ticket EPSON par colis (un
 * ticket ne colle pas au sac). Le QR `FOLIES|<n° commande>|0/<n>` couvre tous
 * les colis de l'arrêt : l'app livreur le valide d'un seul scan
 * (`driver/src/utils/qrColis.ts`, k = 0). Le code à 4 chiffres reste le
 * contrôle de secours.
 */
import { codeCourtColis, contenuQrColis } from './livraisonCaisse';

/** ZPL n'accepte ni ^ ni ~ dans une donnée ; le reste passe en UTF-8 (^CI28). */
const nettoyer = (t: string) => String(t || '').replace(/[\^~\\]/g, ' ').replace(/\s+/g, ' ').trim();

export interface EtiquetteLivraison {
  orderNumber: string;
  nom: string;
  colis: number;
  rang?: number | null;
}

export function etiquetteLivraisonZpl(e: EtiquetteLivraison): string {
  const n = Math.max(1, Math.round(Number(e.colis) || 1));
  const qr = contenuQrColis(e.orderNumber, 0, n);
  const rang = e.rang ? `${e.rang}. ` : '';
  return [
    '^XA',
    '^CI28',
    '^PW400',
    '^LL200',
    '^LH0,0',
    `^FO12,14^BQN,2,5,M^FDMA,${nettoyer(qr)}^FS`,
    `^FO178,14^A0N,26,22^FB214,2,0,L^FD${nettoyer(rang + e.nom)}^FS`,
    `^FO178,74^A0N,36,32^FB214,1,0,L^FD${n} COLIS^FS`,
    `^FO178,116^A0N,32,28^FB214,1,0,L^FDCode ${codeCourtColis(e.orderNumber)}^FS`,
    `^FO178,160^A0N,20,18^FB214,1,0,L^FD${nettoyer(e.orderNumber)}^FS`,
    '^PQ1,0,1,Y',
    '^XZ',
  ].join('\n');
}
